import React from 'react';
import PropTypes from 'prop-types';
import { PageWrapper } from 'virtues-bootstrap';

import Form from 'containers/OrganizationForm/Form';

const OrganizationForm = ({ editMode, initialValues, isSuperCareteam, handleSubmit }) => (
  <PageWrapper tight>
    <Form
      editMode={editMode}
      initialValues={initialValues}
      isSuperCareteam={isSuperCareteam}
      onSubmit={handleSubmit}
    />
  </PageWrapper>
);

OrganizationForm.defaultProps = {
  initialValues: {},
};

OrganizationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
  isSuperCareteam: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    siteId: PropTypes.string,
    name: PropTypes.string,
    participants: PropTypes.arrayOf({}),
  }),
};

export default OrganizationForm;
